import { createGlobalStyle } from 'styled-components';

export default createGlobalStyle`

  * {
    margin: 0;
    padding: 0;
    outline: 0;
    box-sizing: border-box;
  }

  *, ::after, ::before {
    box-sizing: border-box;
  }

  *:focus {
    outline: 0;
  }

  html, body, #root {
    height: 100%;
    max-width: 100%;
    overflow-x: hidden;
  }

  body {
    -webkit-font-smoothing: antialiased;
    background: #F7F8FC;
  }

  body {
    font: 14px 'Rubik', sans-serif;
  }

  input, button, div {
    font: 14px 'Rubik', sans-serif;
  }

  a {
    text-decoration: none;
  }

  ul {
    list-style: none;
  }

  button {
    cursor: pointer;
  }

  table {
    display: table;
    border-collapse: separate;
    box-sizing: border-box;
    border-spacing: 2px;
    border-color: #FFF;
  }

  th {
    z-index: 0;
  }

  /* input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  input:-webkit-autofill:active  {
    box-shadow: 0 0 0 30px white inset !important;
  } */

  ::-webkit-scrollbar {
    width: 10px;
  }

  ::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  ::-webkit-scrollbar-thumb {
    background: #D0A967;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #D0A967;
  }
`;
